import { baseRequest } from '@/utils/request'

const request = (url, ...arg) =>  baseRequest(`/biz/c/imuser/${url}`, ...arg)

export default {
	// 获取企业IM信息
	imCompanyDetail(data) {
		return request('companyDetail', data, 'get')
	},
	// 企业向个人发起聊天，通过userId获取个人IM信息
	imByCompany(data) {
		return request('imByCompany', data, 'get')
	},
	// 获取个人IM信息
	imUserDetailOnLogin(data) {
		return request('userDetailOnLogin', data, 'get')
	},
	// 个人向企业发起聊天，获取个人用户IM详情并自动创建IM用户
	imUserDetailOnSend(data) {
		return request('userDetailOnSend', data, 'get')
	},
	// 个人向企业发起聊天，通过企业id获取企业IM信息
	imByUser(data) {
		return request('imByUser', data, 'get')
	},
	// 获取IM用户信息列表
	imUserInfoByIds(data) {
		return request('getImUserInfoByIds', data, 'post')
	},
}
